import { render, staticRenderFns } from "./data11.vue?vue&type=template&id=4e1a57e4&scoped=true&"
import script from "./data11.vue?vue&type=script&lang=js&"
export * from "./data11.vue?vue&type=script&lang=js&"
import style1 from "./data11.vue?vue&type=style&index=1&id=4e1a57e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1a57e4",
  null
  
)

export default component.exports